/* eslint-disable max-len */
import React from "react";

export function EmergencyAlarmIcon({
  height, // number type by default
  width,
  viewBox = "0 0 24 24",
  svgColor,
}: CustomSVGProp) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox || "0 0 24 24"}
    >
      <path
        d="M12.75 2C12.75 1.58579 12.4142 1.25 12 1.25C11.5858 1.25 11.25 1.58579 11.25 2V5C11.25 5.41421 11.5858 5.75 12 5.75C12.4142 5.75 12.75 5.41421 12.75 5V2Z"
        fill={svgColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 21.25H4V16C4 11.5817 7.58172 8 12 8C16.4183 8 20 11.5817 20 16V21.25H22C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22C1.25 21.5858 1.58579 21.25 2 21.25ZM12.75 18.7993C13.1984 18.54 13.5 18.0552 13.5 17.5C13.5 16.6716 12.8284 16 12 16C11.1716 16 10.5 16.6716 10.5 17.5C10.5 18.0552 10.8016 18.54 11.25 18.7993V21.25H12.75V18.7993ZM13.5953 11.2186C13.7507 10.8346 14.188 10.6494 14.5719 10.8048C15.7629 11.2869 16.7129 12.2369 17.195 13.4278C17.3504 13.8118 17.1651 14.249 16.7812 14.4044C16.3972 14.5599 15.96 14.3746 15.8046 13.9907C15.4749 13.1762 14.8235 12.5249 14.0091 12.1952C13.6252 12.0398 13.4399 11.6025 13.5953 11.2186Z"
        fill={svgColor}
      />
      <path
        d="M21.5303 5.46967C21.8232 5.76256 21.8232 6.23744 21.5303 6.53033L20.0303 8.03033C19.7374 8.32322 19.2626 8.32322 18.9697 8.03033C18.6768 7.73744 18.6768 7.26256 18.9697 6.96967L20.4697 5.46967C20.7626 5.17678 21.2374 5.17678 21.5303 5.46967Z"
        fill={svgColor}
      />
      <path
        d="M3.53033 5.46967C3.23744 5.17678 2.76256 5.17678 2.46967 5.46967C2.17678 5.76256 2.17678 6.23744 2.46967 6.53033L3.96967 8.03033C4.26256 8.32322 4.73744 8.32322 5.03033 8.03033C5.32322 7.73744 5.32322 7.26256 5.03033 6.96967L3.53033 5.46967Z"
        fill={svgColor}
      />
    </svg>
  );
}
export default EmergencyAlarmIcon;
